/**
 * Dashboard Controls Component
 * Grid column selector
 */

import React from "react";
import { LayoutGrid } from "lucide-react";
import { Button } from "../../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";

interface DashboardControlsProps {
  gridColumns?: number;
  onGridColumnsChange?: (columns: number) => void;
}

export function DashboardControls({
  gridColumns = 2,
  onGridColumnsChange,
}: DashboardControlsProps) {
  if (!onGridColumnsChange) return null;

  // Normalize gridColumns to valid dropdown value (1, 2, or 3)
  // This ensures the dropdown always highlights the correct option
  const normalizedColumns = (() => {
    if (gridColumns === 1 || gridColumns === 2 || gridColumns === 3) {
      return gridColumns;
    }
    // If value is invalid (e.g., 4, undefined, or null), default to 2
    return 2;
  })();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <LayoutGrid className="h-4 w-4" />
          {normalizedColumns} Column{normalizedColumns !== 1 ? "s" : ""}
        </Button>
      </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              onClick={() => onGridColumnsChange(1)}
              className={`cursor-pointer hover:bg-accent hover:text-accent-foreground ${normalizedColumns === 1 ? "bg-accent text-accent-foreground" : ""}`}
              onSelect={(e) => e.preventDefault()}
            >
              1 Column
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => onGridColumnsChange(2)}
              className={`cursor-pointer hover:bg-accent hover:text-accent-foreground ${normalizedColumns === 2 ? "bg-accent text-accent-foreground" : ""}`}
              onSelect={(e) => e.preventDefault()}
            >
              2 Columns
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => onGridColumnsChange(3)}
              className={`cursor-pointer hover:bg-accent hover:text-accent-foreground ${normalizedColumns === 3 ? "bg-accent text-accent-foreground" : ""}`}
              onSelect={(e) => e.preventDefault()}
            >
              3 Columns
            </DropdownMenuItem>
          </DropdownMenuContent>
    </DropdownMenu>
  );
}
